import { Component, Input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-icon-button',
  template: `
    <a mat-icon-button class="button-icon" [href]="href" [target]="target">
      <mat-icon>{{ icon }}</mat-icon>
    </a>
  `,
  styleUrls: ['buttons.scss'],
  imports: [MatIconButton, MatIcon],
})
export class IconButtonComponent {
  @Input() icon: string;
  @Input() href: string;
  @Input() target = '_self';

  constructor() {}
}
